import { Button, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useState } from "react";

import useCheckPermissions from "../../../hooks/useCheckPermissions";
import { PERMISSIONS } from "../../../const/permissions.const";
import DisabledActionWrapper from "../../../yoello-lib/modules/components/DisabledActionWrapper";

interface IOrderActionButtonsProps {
    colour: any;
    onClick: any;
    label: string;
    isDisabled?: boolean;
    isRefund?: boolean;
    fontColour?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        color: ({ fontColour }: IOrderActionButtonsProps) => fontColour ?? '#FFFFFF',
        backgroundColor: ({ colour }: IOrderActionButtonsProps) => colour,
        '&:hover': {
            backgroundColor: ({ colour }: IOrderActionButtonsProps) => colour,
        },
        fontFamily: "Open Sans!important",
        fontStyle: "normal!important",
        fontWeight: 600,
        fontSize: "0.9375rem!important",
        lineHeight: "1.25rem!important",
        display: "flex!important",
        alignItems: "center!important"
    }
}));
export function OrderActionButtons(props: IOrderActionButtonsProps) {
    const { root } = useStyles(props);
    const [isDisabled, setIsDisabled] = useState(false);

    const { hasPermission, onFailedInteraction } = useCheckPermissions(
        props.isRefund ?
        PERMISSIONS.REFUNDS :
        PERMISSIONS.ORDER_PROCESSING
    );

    async function onClick() {
        setIsDisabled(true);
        await props.onClick();
        setIsDisabled(false);
    }
    return <DisabledActionWrapper
        disabled={!hasPermission}
        onDisabledClick={onFailedInteraction}
    >
        <Button
            className={root}
            variant="contained"
            onClick={onClick}
            disabled={isDisabled || !hasPermission}
        >
            {props.label}
        </Button>
    </DisabledActionWrapper>
    
}